// Module
var code = "<div class=\"needletail-grouped-search-bar needletail-grouped-search-bar-{{ name }}\"> <input type=\"text\" class=\"needletail-grouped-search-bar-input needletail-empty\" autocomplete=\"off\" spellcheck=\"false\" placeholder=\"{{ placeholder }}\"> {{{ results }}} </div>";
// Exports
export default code;